import { type GetCustomerResponse, GetCustomerResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions, CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useCustomerOptions(customerId: string, api = getPrivateApi()): CustomBaseUseQueryOptions<GetCustomerResponse> {
  return {
    queryKey: ['customer', 'customer-id', customerId],
    suspense: true,
    queryFn: async () => {
      const getCustomerResponse = await api.getCustomer({ customerId });

      return GetCustomerResponseSchema.parse(getCustomerResponse);
    },
  };
}

export function useCustomer(customerId:string, options?: CustomUseQueryOptions<GetCustomerResponse>) {
  const customerOptions = useCustomerOptions(customerId);

  return useQuery({ ...customerOptions, ...options });
}